import { type ScanDetectorConfig } from '../types/scanDetector.type';

export const SCAN_DETECTION_DEFAULTS: ScanDetectorConfig = {
  // Idle time after the latest character. When it passes with no new key, the buffer closes and is judged.
  bufferTimeoutMs: 600,
  // After an accepted scan, the same barcode is ignored if it arrives again within this window.
  duplicateWindowMs: 400,
  // How many gaps slower than maxInterKeyMs one candidate may contain.
  interKeySlackCount: 3,
  // Maximum average gap between consecutive characters in the candidate.
  maxAvgTimeMs: 60,
  // Maximum time from the first buffered character to the last.
  maxDurationMs: 1200,
  // A gap longer than this counts as one slow gap toward interKeySlackCount.
  maxInterKeyMs: 60,
  // Candidates shorter than this are discarded and never judged as a scan.
  minLength: 3,
  // Keys that close the buffer immediately and are not part of the barcode.
  suffixDetection: ['Enter', 'Tab'],
};
